export default "/kiban/_next/static/images/35_10L_other-b51c60e450c3ce28825dc0f476008e66.png";